function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.83757 9.75971C6.39659 7.41575 6.94362 5.06879 7.52164 2.73083C7.90466 1.18585 8.53268 0.758859 10.0507 1.12085C13.1889 1.87084 16.318 2.66383 19.4411 3.47181C20.7692 3.81381 21.2192 4.5648 20.9032 5.90977C19.7601 10.7647 18.6001 15.6136 17.424 20.4605C17.113 21.7415 16.385 22.2145 15.127 21.9115C11.8708 21.1265 8.62069 20.3095 5.37555 19.4715C4.1715 19.1596 3.79049 18.4126 4.1055 17.0376C4.66152 14.6056 5.25755 12.1837 5.83757 9.75971Z",
  fill: "#FF3819"
});

var SvgRedcard = function SvgRedcard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedcard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redcard.982fec2d.svg";
export { ForwardRef as ReactComponent };